<template>
  <div
    class="content"
    :style="`height: ${target !== 'qzxx' ? '436px' : '365px'}`"
  >
    <div class="content-box">
      <div
        v-for="item in list"
        :key="item.code"
        class="box tab"
        :class="[{ out: item.isShow }]"
        @mouseenter="changeTag(item)"
        @click="titleDetail(item)"
        :style="
          item === target &&
          'border-bottom: 2px solid rgba(203, 180, 134, 1); color: #000;'
        "
      >
       <span :title="item.name">{{ item.name }}</span> 
      </div>
      <div class="scoll">
        <div
          v-show="
            target.contentECount > 1 &&
            target.moduleClass == 'announce' &&
            index <= 4
          "
          v-for="(item, index) in data"
          :key="item.contentCode"
          class="tab-box"
          @click="goDetail(item)"
        >
          <span class="tab-text">{{ item.contentTitle }}</span>
          <span class="tab-date" v-if="String(item.createTime).length === 10">{{
            item.createTime
          }}</span>
          <span class="tab-date" v-else>{{
            String(item.createTime).split(" ")[0]
          }}</span>
        </div>
        <div
          v-html="detail"
          v-show="target.contentECount == 1 && target.moduleClass == 'announce'"
          class="html-content design-html"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
// const list = [
//   { name: "签证信息", isShow: true, key: "qzxx", code: "RESD2F68E16A9669D5" },
//   { name: "常见问题", isShow: true, key: "cjwt", code: "RESE617B90AE3AA5FA" },
//   { name: "赴日须知", isShow: false, key: "frxz", code: 'RES82B0F4428490544' },
//   { name: "联系方式", isShow: false, key: "lxfs", code: 'RESEA620424D880B51' },
// ];
const data = [
  { title: "入境日本政策变更", date: "2021-03-08" },
  { title: "省外事服务中心领导慰问中心患病员工", date: "2021-03-08" },
  { title: "表彰慰问外企员工，宣传做好疫情防控", date: "2021-03-08" },
  { title: "外交部领事司领事认证工作调研组来闽调", date: "2021-03-08" },
];
import {
  getInfo,
  getIssue,
  getNeedKnow,
  getIssueDetail,
  getNeedKnowDetail,
  getConnect,
  getInfoTitle,
  getListData,
  getText,
} from "@/api/goaborad.js";
export default {
  name: "choose-tab",
  data() {
    return {
      list: [],
      data,
      target: "",
      detail: "",
      isShow: false,
    };
  },
  created() {
    getInfoTitle().then((res) => {
      res.data.records.forEach((e) => {
        this.list.push({
          name: e.moduleName,
          code: e.moduleCode,
          contentECount: e.contentECount,
          moduleClass: e.moduleClass,
        });
      });
      this.target = this.list[0] || "";
      this.getList();
    });
  },
  mounted: {},
  methods: {
    goDetail(item) {
      const type = "contentAnnounce";
      // const name = this.list.find((item) => item.key === this.target).name;
      this.pushRouter(
        `/guide?contentCode=${item.contentCode}&type=${type}&linkname=出国签证/签证信息/详情`
      );
    },
    titleDetail(item) {
      if (item.contentECount > 1 && item.moduleClass == "announce") {
        this.pushRouter(
          "/announcement?moduleCode=" +
            item.code +
            "&type=contentAnnounce&name=" +
            item.name+`&linkname=出国签证/${item.name}`
        );
      }
      if (item.contentECount == 1 && item.moduleClass == "announce") {
        getText(item.code).then((res) => {
          const data = this._.get(res, "data.records.0", {});
          this.pushRouter(
            "/guide?contentCode=" +
              data.contentCode +
              "&type=contentAnnounce&linkname=出国签证" +
              data.contentTitle +
              "/详情"
          );
        });
      }
    },
    getList() {
      this.list.forEach((e) => {
        if (
          e == this.target &&
          e.contentECount > 1 &&
          e.moduleClass == "announce"
        ) {
          getListData(e.code).then((res) => {
            this.data = this._.get(res, "data.records", []);
          });
          return;
        }
        if (
          e == this.target &&
          e.contentECount == 1 &&
          e.moduleClass == "announce"
        ) {
          getText(e.code).then((res) => {
            const data = this._.get(res, "data.records.0", {});
            getIssueDetail(data.contentCode, data.tenantCode).then((res) => {
              this.detail = this._.get(res, "data.contentHtml", "");
            });
          });
          return;
        }
      });
      // switch (this.target) {
      //   case "qzxx":
      //     getInfo().then((res) => {
      //       this.data = this._.get(res, "data.records", []);
      //     });
      //     break;
      //   case "cjwt":
      //     getIssue().then((res) => {
      //       const data = this._.get(res, "data.records.0", {});
      //       getIssueDetail(data.contentCode, data.tenantCode).then((res) => {
      //         this.detail = this._.get(res, "data.contentHtml", "");
      //       });
      //     });
      //     break;
      //   case "frxz":
      //     getNeedKnow().then((res) => {
      //       const data = this._.get(res, "data.records.0", {});
      //       getNeedKnowDetail(data.contentCode, data.tenantCode).then((res) => {
      //         this.detail = this._.get(res, "data.contentHtml", "");
      //       });
      //     });
      //     break;
      //   case "lxfs":
      //     getConnect().then((res) => {
      //       this.detail = this._.get(res, "data.contentHtml", "");
      //     });
      //     break;
      // }
    },
    switch() {},
    changeTag(val) {
      this.target = val;
      this.getList();
    },
  },
};
</script>

<style scoped lang='less'>
.box.tab.out {
  cursor: pointer !important;
}
.content {
  width: 100%;
  height: 365px;
  position: relative;
  margin-bottom: 40px;
}
.content-box {
  width: 1140px;
  // position: absolute;
  // left: 50%;
  // transform: translateX(-50%);
  position: relative;
  margin: auto;
  text-align: left;
}
.box {
  display: inline-block;
  vertical-align: middle;
  text-align: left;
  margin-right: 45px;
}
.box:hover {
  cursor: pointer;
}
.tab {
  width: 80px;
  height: 20px;
  padding-bottom: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(188, 190, 192, 1);
  cursor: pointer;
  // cursor: default !important;
}
.tab-box {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 28px 0 32px 15px;
  border-bottom: 1px solid rgba(238, 238, 238, 1);
  position: relative;
  cursor: pointer;
}
.tab-box::before {
  content: "";
  display: inline-block;
  width: 5px;
  height: 5px;
  background: rgba(203, 180, 134, 1);
  border-radius: 50%;
  position: absolute;
  left: 0px;
  top: 39px;
}

.tab-text {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #3d4652;
  width: 86%;
  &:hover {
    color: rgba(203, 180, 134, 1);
  }
}
.tab-date {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #bcbec0;
  &:hover {
    color: rgba(203, 180, 134, 1);
  }
}
.scoll {
  height: 340px;
  /* overflow: hidden; */
  /* overflow-y: scroll; */
}
.html-content {
  font-size: 18px;
  font-family: "微软雅黑";
  font-weight: 400 !important;
  margin-top: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/home/goaboard/siderContent-03.vue